import React from "react"
import {injectIntl} from "@irati/utils/lang"
import {InjectIntlProps} from "@irati/utils/lang/injectIntl"
import theme from "@irati/ui/src/global/theme"
import {Card} from "@irati/ui/src/Layout"
import {Body} from "@irati/ui/src/Typography"
import Container from "../styled/Container"
import {StyledMarkdown} from "../../components/NewRewardModal/styled"
import NewRewardWalletContent from "../../components/NewRewardModal/NewRewardWalletContent"

const NewRewardWallet: React.FC<InjectIntlProps> = (props) => {
  const {formatMessage} = props
  return (
    <Container>
      <Card bgColor={theme.colors.primary2_400}>
        <Body color={theme.colors.greys.white}>
          <StyledMarkdown source={formatMessage({id: "wallet.newRewardAlert.disabledTopup.message"})} />
        </Body>
      </Card>
      <NewRewardWalletContent />
    </Container>
  )
}

export default injectIntl(NewRewardWallet)
